import type { Weekday } from '@/shared/dateInterest/weekday';

export type { Weekday } from '@/shared/dateInterest/weekday';

export interface Account {
  id: number;
  email: string;
  country_code: string;
  to_country_code: string;
  valid: boolean;
  blocked: boolean;
  flagged: boolean;
}

export interface Facility {
  code: string;
  name: string;
}

export interface Participant {
  name: string;
  document: string;
  position: number;
}

export interface DateRangeSpan {
  from: string;
  to: string;
}

export interface AcceptedDateRange extends DateRangeSpan {
  appointment_days: Weekday[];
}

export interface DateInterest {
  configured: boolean;
  accept: AcceptedDateRange[];
  exclude: DateRangeSpan[];
  min_days_from_now: number;
  max_gap_between_asc_and_consular: number | null;
  min_same_day_gap: number | null;
  allow_cancellation: boolean;
  accept_worse_date: boolean;
}

export const BOOKABLE_APPLICATION_STATES = ['unknown', 'awaiting_booking', 'booked'] as const;
export const REFUSING_APPLICATION_STATES = ['awaiting_payment', 'concluded'] as const;

export const APPLICATION_STATES = [
  ...BOOKABLE_APPLICATION_STATES,
  ...REFUSING_APPLICATION_STATES,
] as const;

export type ApplicationState = (typeof APPLICATION_STATES)[number];

export interface Schedule {
  id: number;
  account_id: number;
  external_id: string | null;
  status: 'active' | 'paused' | 'completed' | 'cancelled';
  application_state: ApplicationState;
  bookable: boolean;
  funded: boolean;
  reactivatable: boolean;
  date_interest: DateInterest;
  asc_required: boolean;
  current_consular_at: string | null;
  current_asc_at: string | null;
  current_consular_facility: Facility | null;
  preferred_facilities: Facility[] | null;
  participants: Participant[] | null;
}

export interface ScheduleActivity {
  id: number;
  activity_type: string;
  details: Record<string, unknown> | null;
  created_at: string;
}

export interface CreateAccountResponse {
  account: Account;
  schedules: Schedule[];
}
